export default {
  SET_RESERVAS(state, lista) {
    state.reservas = lista
  },
  ADD_RESERVAS(state, lista) {
    state.reservas = state.reservas.concat(lista)
  },
  SET_MINHAS_RESERVAS(state, lista) {
    state.minhasReservas = lista
  },
  ADD_MINHAS_RESERVAS(state, lista) {
    state.minhasReservas = state.minhasReservas.concat(lista)
  },
  DELETE_MINHAS_RESERVAS(state, reservaCancelada) {
    state.minhasReservas = state.minhasReservas.filter(
      r => r.id !== reservaCancelada.id,
    )
  },
  SET_AREAS_DISPONIVEIS(state, lista) {
    state.areasDisponiveis = lista
  },
  SET_RESERVA_EM_ANDAMENTO(state, reservaEmAndamento) {
    state.reservaEmAndamento = reservaEmAndamento
  },
  SET_TERMO_RESERVA_EM_ANDAMENTO(state, termoReservaEmAndamento) {
    state.termoReservaEmAndamento = termoReservaEmAndamento
  },
  SET_CONVIDADOS(state, convidados) {
    state.convidados = convidados
  },
  ADD_CONVIDADO(state, convidado) {
    state.convidados = [...state.convidados, convidado]
  },
  REMOVE_CONVIDADO(state, id) {
    state.convidados = state.convidados.filter(c => c.id !== id)
  },
  UPDATE_CONVIDADO(state, convidado) {
    const idx = state.convidados.findIndex(c => c.id === convidado.id)
    if (idx !== -1) {
      state.convidados.splice(idx, 1, convidado)
    }
  },
}
